<app-adminav></app-adminav>
<div class="container">
    <div class="col-lg-12 mt-5">
        <h3>Lista de suscriptores</h3>
        <hr>
        <table class="table table-hover mt-3">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">Fecha de suscripción</th>
                    <th scope="col">E-mail</th>
                </tr>
            </thead>
            <tbody class="text-left">
                <tr *ngFor="let suscriptores of lista ">
                    <td>{{suscriptores.fecha.toDate() | date:'yyyy/MM/dd h:mm:ss a'}}</td>
                    <td>{{suscriptores.email}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>